import styled from 'styled-components';
import { layout, LayoutProps, space, SpaceProps } from 'styled-system';

// Components.
import FallbackSVG from './Fallback';
import { IThemeProps } from 'component/theme';
import { FONT_DEFAULT } from '../../../constants/originalState';

// Size mapping.
export const sizeMapping = {
  sm: '25px',
  md: '50px',
  lg: '75px'
};

/**
 * Avatar sizes.
 */
export type AvatarSizeType = 'sm' | 'md' | 'lg';

export interface IStyledAvatarProps extends LayoutProps, SpaceProps {
  /**
   * Describes the avatar or what it represents.
   */
  alt: string;
  /**
   * Size of avatar.
   */
  size?: AvatarSizeType;
  /**
   * URL of image to render.
   *
   * @default "Fallback image"
   */
  imagePath?: string;
}

/**
 * Avatar with provided image.
 */
export const StyledAvatar = styled.img.attrs((props: IStyledAvatarProps) => ({
  src: props.imagePath,
  alt: props.alt,
  size: props.size
}))<IStyledAvatarProps>`
  ${layout};
  ${space};
  width: ${({ size }) => (size ? sizeMapping[size] : null)};
  height: ${({ size }) => (size ? sizeMapping[size] : null)};
  border-radius: 50%;
  object-fit: cover;
`;

/**
 * Avatar with fallback image.
 */
export const Fallback = styled(FallbackSVG)<IStyledAvatarProps>`
  ${layout};
  ${space};
  width: ${({ size }) => (size ? sizeMapping[size] : sizeMapping['md'])};
  height: ${({ size }) => (size ? sizeMapping[size] : sizeMapping['md'])};
  border-radius: 50%;
`;

export const StyledAvatarCustom = styled.div`
  ${({ theme }: IThemeProps) => `
    .MuiAvatar-root {
      border: solid 2px ${theme.uptimeColors.generalColors.icon.enabled};
      border-radius: 50%;
      background-color: transparent !important;
      font-family: '${theme.uptimeFonts.primary || FONT_DEFAULT}' !important;
      display: flex;
      justify-content: center;
      color: ${theme.uptimeColors.generalColors.icon.enabled};
      font-size: 16px;
      font-weight: bold;
      padding-top: ${theme.uptimeDynamicAlignCenter?.avatarUser?.paddingTop ?? `${theme.uptimeSpace[2]}px`};
      &.avatar-large {
        border-width: 4px;
        font-size: 50px;
      }
    }
  `}
`;
